import { useMemo } from 'react';
import { BreakTypeInfo } from '../../components/BreakTypeIcon';
import { useMyTimeTrackingSettings } from './useMyTimeTrackingSettings';

/** Minimal shape for default-break lookup (matches active break types from settings query). */
export type BreakTypeForDefaultLookup = {
  Id: string;
  flair__Is_Active__c: boolean;
  flair__Is_Default__c?: boolean | null;
  flair__Sort_Order__c?: number | null;
};

export function getDefaultBreakTypeId(
  breakTypes: readonly BreakTypeForDefaultLookup[],
): string | undefined {
  const sorted = [...breakTypes]
    .filter((bt) => bt.flair__Is_Active__c)
    .sort(
      (a, b) => (a.flair__Sort_Order__c ?? 0) - (b.flair__Sort_Order__c ?? 0),
    );
  const def = sorted.find((bt) => bt.flair__Is_Default__c === true);
  return def?.Id;
}

export const useBreakTypes = (): BreakTypeInfo[] => {
  const { data } = useMyTimeTrackingSettings();

  return useMemo(() => {
    const breakTypes = data?.me.workloads?.[0]?.timeFramework?.breakTypes ?? [];

    return breakTypes
      .filter((bt) => bt.flair__Is_Active__c)
      .sort(
        (a, b) => (a.flair__Sort_Order__c ?? 0) - (b.flair__Sort_Order__c ?? 0),
      );
  }, [data]);
};

export const useDefaultBreakTypeId = (): string | undefined => {
  const { data } = useMyTimeTrackingSettings();

  return useMemo(() => {
    const breakTypes = data?.me.workloads?.[0]?.timeFramework?.breakTypes ?? [];
    return getDefaultBreakTypeId(breakTypes);
  }, [data]);
};
